import { Structure } from "util/stdtypes";
import { useIsAdmin } from "component/admin";
import { Banner } from "component/banner";
import { FlowBox, Pad, PadBox, WindowTitle } from "component/basics";
import { ConversationScreen } from "component/screen";
import { ActionButton } from "component/button";
import { Heading, UtilityText } from "component/text";
import { useDatastore } from "util/datastore";
import { useConfig } from "util/features";
import { colorTextOnLightColorTag } from "component/color";

export type QuickLink = {label: string, structureKey?: string, screenKey?: string}

export type AdminConfig = {
    quickLinks?: QuickLink[];
    panels?: React.ComponentType[];
}

export const AdminStructure : Structure<AdminConfig> = {
    key: 'admin',
    name: 'Admin Dashboard',
    screen: AdminScreen,
    hasFocusTrap: true,
    defaultConfig: {
        quickLinks: [  // TODO: Specify capability required to see each link
            {label: 'Component Demo', structureKey: 'componentdemo'},
        ],
    }
}

export function AdminScreen() {
    const {quickLinks} = useConfig<AdminConfig>();
    const isAdmin = useIsAdmin();

    if (!isAdmin) {
        return <Banner><UtilityText label='Admin Only' color={colorTextOnLightColorTag}/></Banner>
    }

    return <ConversationScreen pad>
        <WindowTitle label='Admin Dashboard' />
        <Pad/>
        <Heading type="large" weight="medium" label='Admin Dashboard' />
        <Pad />
        <Heading label='Quick Links' />
        <FlowBox>
            {quickLinks?.map(quickLink => <PadBox top={8} right={8} key={quickLink.label}>
                <QuickLink quickLink={quickLink} />
            </PadBox>)}
        </FlowBox>
        <Pad />
    </ConversationScreen>
}

function QuickLink({quickLink}) {
    const {label, structureKey, screenKey} = quickLink;
    const datastore = useDatastore();
    function onPress() {
        if (structureKey) {
            datastore.gotoInstance({structureKey, instanceKey: 'one'});
        } else if (screenKey) {
            datastore.pushSubscreen(screenKey);
        }
    }
    return <ActionButton label={label} onPress={onPress} />
}
